import { useEdgeGroups } from '@/react/edge/edge-groups/queries/useEdgeGroups';

import {
  DeploymentType,
  DEPLOYMENT_TYPE_ENVIRONMENT_TYPE,
} from '../../detectDeploymentType';

export function useEdgeGroupsForDeploymentType(deploymentType: DeploymentType) {
  const environmentType = DEPLOYMENT_TYPE_ENVIRONMENT_TYPE[deploymentType];
  const edgeGroupsQuery = useEdgeGroups({ summarize: true });

  return {
    ...edgeGroupsQuery,
    data: edgeGroupsQuery.data?.filter((group) =>
      group.EndpointTypes.includes(environmentType)
    ),
  };
}
